import { render, staticRenderFns } from "./glDialog.vue?vue&type=template&id=73590ef0&scoped=true"
import script from "./glDialog.vue?vue&type=script&lang=js"
export * from "./glDialog.vue?vue&type=script&lang=js"
import style0 from "./glDialog.vue?vue&type=style&index=0&id=73590ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73590ef0",
  null
  
)

export default component.exports